export interface PanelDataTableProps {
  props: { columns: string[]; rows: unknown[][] };
}

export function PanelDataTable({ props }: PanelDataTableProps) {
  const { columns, rows } = props;

  return (
    <div className="overflow-x-auto rounded-sd-sm border border-sd-border/40">
      <table className="border-collapse w-full text-sd-sm">
        <thead className="bg-sd-surface-elevated/80 border-b border-sd-border/40">
          <tr>
            {columns.map((col, i) => (
              <th
                key={i}
                className="px-3 py-1.5 font-semibold text-left text-sd-text-secondary text-sd-xs uppercase tracking-wider whitespace-nowrap"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr
              key={ri}
              className="even:bg-sd-surface-elevated/30 transition-colors hover:bg-sd-surface-elevated/50"
            >
              {row.map((cell, ci) => (
                <td key={ci} className="px-3 py-1.5 border-t border-sd-border/20 text-sd-text">
                  {String(cell ?? '')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
